import { Box, Button, Card, CardContent, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import PageHeader from "../../../materio/@core/components/page-header";
import SimpleDialog from "../../common/SimpleDialog";
import { CustomerDetail } from "./CustomerDetailsTable";
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useRef, useState } from "react";
import { cloneDeep, isEmpty } from "lodash";
import useOptions from "../../../hooks/useOptions";
import FallbackSpinner from "../../../materio/@core/components/spinner";
import { client } from "../../../utils/axios-client";
import { ApiResponseType } from "../../../types";
import ApplicationStore from "../../../stores/ApplicationStore";
import WysiwygEditor from "../../common2/Templating/WysiwygEditor";
import { PhoneNumber } from "./PhoneNumberTable";
import { useAudioRecorder } from "../../../lib/react-audio-recorder-master/src";
import { Recorder } from "vmsg";
import RecordIcon from '@mui/icons-material/FiberManualRecord';
import StopIcon from '@mui/icons-material/Stop';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { v4 as uuid } from 'uuid';

type Props = {
    open: boolean,
    onClose: () => void,
    record: PhoneNumber,
}

const addAudioElement = (data: Blob) => {
    console.log(data);
    //const audio = document.createElement('audio');
    //audio.src = url;
    //audio.controls = true;
    //document.body.appendChild(audio);
};

const recorder = new Recorder({
    wasmURL: "/js/vmsg.wasm"
});

const EditPhoneNumber = ({ open, onClose, record }: Props) => {
    const [data, setData] = useState<PhoneNumber>({} as PhoneNumber);
    const [loading, setLoading] = useState(true);
    const { options: countries } = useOptions("COUNTRY");
    const [isLoading, setIsLoading] = useState(false);
    const [isRecording, setIsRecording] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const [recordings, setRecorings] = useState<any>();
    const audioRef = useRef<HTMLAudioElement | any>();
    //useEffect(() => {
    //    const mediaDevices = navigator.mediaDevices as any;        

    //    mediaDevices.getUserMedia({ audio: true },
    //        () => {
    //            console.log('Permission Granted');
    //            setIsBlocked(false);                
    //        },
    //        () => {
    //            console.log('Permission Denied');
    //            setIsBlocked(true);
    //        },
    //    );
    //}, [])

    const recordAudio = async () => {
        setIsLoading(true);

        if (isRecording) {
            const blob = await recorder.stopRecording();

            setIsLoading(false);
            setIsRecording(false);
            setRecorings(URL.createObjectURL(blob))

            var host = window.location.protocol + "//" + window.location.host;
            var newId = uuid();

            const form = new FormData();
            form.append("files", blob, "record.mp3");
            form.append("phoneNumbersId", newId);
            const response2 = await client.post('/api/admin/users/phone-numbers/voicemail', form);

            setData({ ...data, voiceMessageURL: `/api/admin/users/phone-numbers/voicemail/${newId}` });

        } else {
            try {
                await recorder.initAudio();
                await recorder.initWorker();
                recorder.startRecording();
                setIsLoading(false);
                setIsRecording(true);
            } catch (e) {
                console.error(e);
                setIsLoading(false);
            }
        }
    };

    useEffect(() => {
        setData(record);
        setLoading(false);
    }, [record])

    const onSave = async () => {
        var hasError = false;
        var temp = cloneDeep(data);
        
        if (isEmpty(temp.number)) {
            hasError = true;
            temp.numberError = true;
        } else {
            temp.numberError = false;
        }

        if (isEmpty(temp.friendlyName)) {
            hasError = true;
            temp.friendlyNameError = true;
        } else {
            temp.friendlyNameError = false;
        }

        if (isEmpty(temp.countryId)) {
            hasError = true;
            temp.countryIdError = true;
        } else {
            temp.countryIdError = false;
        }

        if (isEmpty(temp.sid)) {
            hasError = true;
            temp.sidError = true;
        } else {
            temp.sidError = false;
        }

        if (isEmpty(temp.location)) {
            hasError = true;
            temp.locationError = true;
        } else {
            temp.locationError = false;
        }

        if (isEmpty(temp.incomingCallAction)) {
            hasError = true;
            temp.incomingCallActionError = true;
        } else {
            temp.incomingCallActionError = false;

            if (isEmpty(temp.forwardToNumber) && temp.incomingCallAction === "FORWARD") {
                hasError = true;
                temp.forwardToNumberError = true;
            } else {
                temp.forwardToNumberError = false;


            }
        }

        if (hasError) {
            setData(temp);
            return;
        }

        const response = await client.post<ApiResponseType>(`/api/admin/users/phone-numbers`, data);

        if (response.data.succeeded) {
            ApplicationStore.update(s => {
                s.snackbarMessage = "Phone Number Saved Successfully";
                s.snackbarOpen = true;
            })

            onClose();
        } else {
            alert('error saving phone number');
        }
    }

    const onUpdateInt = async (prop: string, value: string) => {
        const temp = cloneDeep(data);
        temp[prop] = parseInt(value);
        setData(temp);
    }

    const onUpdateString = async (prop: string, value: string) => {
        const temp = cloneDeep(data);
        temp[prop] = value;
        setData(temp);
    }

    const onUpdateBoolean = async (prop: string, value: boolean) => {
        const temp = cloneDeep(data);
        temp[prop] = value;
        setData(temp);
    }

    const onUpdateArray = async (prop: string, value: string[]) => {
        const temp = cloneDeep(data);
        temp[prop] = value;
        setData(temp);
    }

    const playMP3 = () => {
        if (audioRef.current) {
            if (isPlaying) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
                setIsPlaying(false)
            } else {
                audioRef.current.play();
                setIsPlaying(true)
            }

        }
    }

    if (loading || countries.length === 0) return null;

    return <SimpleDialog open={open} onClose={onClose} size='md'>
        <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: 4 }}>
            <Box sx={{ display: 'flex' }}>
                <Box sx={{ minWidth: 350 }}>
                    <PageHeader
                        title={<Typography variant='h5'>Edit Phone Number</Typography>}
                    />
                </Box>
            </Box>
            <Box sx={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                <Typography sx={{ fontSize: 16, color: 'CornflowerBlue' }}>
                    Voicemail
                </Typography>
                <Button disabled={isLoading} onClick={recordAudio} variant="outlined" size="small" endIcon={isRecording ? <StopIcon /> : <RecordIcon />}>
                    {isRecording ? "Stop Recording" : "Start Recording"}
                </Button>
                <ul style={{ listStyle: "none", padding: 0 }}>
                    {data.voiceMessageURL && <Button variant="outlined" size="small" endIcon={isPlaying ? <StopIcon /> : <PlayArrowIcon />} onClick={playMP3}>
                        {isPlaying ? "Stop Playing" : "Play Voicemail"}
                    </Button>}
                    {data.voiceMessageURL &&
                        <li key={data.voiceMessageURL} style={{ display: 'none' }}>
                            <audio controls ref={audioRef} onEnded={() => setIsPlaying(false)}>
                                <source src={data.voiceMessageURL} type="audio/mpeg" />
                            </audio>
                        </li>
                    }
                </ul>
            </Box>
            <Box sx={{ display: 'flex', gap: 4 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: 8, flexBias: 0, flexGrow: 1 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: 4, minWidth: 350 }}>

                        <Box>
                            <TextField error={data.numberError} fullWidth label="Phone Number" placeholder="Phone Number" size="small" type="text" value={data.number} onChange={(e) => onUpdateString('number', e.target.value)} />
                        </Box>
                        <Box>
                            <TextField error={data.friendlyNameError} fullWidth label="Friendly Name" placeholder="Friendly Name" size="small" type="text" value={data.friendlyName} onChange={(e) => onUpdateString('friendlyName', e.target.value)} />
                        </Box>
                        <Box>
                            <TextField error={data.sidError} fullWidth label="SID" placeholder="SID" size="small" type="text" value={data.sid} onChange={(e) => onUpdateString('sid', e.target.value)} />
                        </Box>
                        <Box>
                            <FormControl fullWidth size="small">
                                <InputLabel id="country-label">Country</InputLabel>
                                <Select
                                    error={data.countryIdError}
                                    label="Country"
                                    labelId="country-label"
                                    fullWidth
                                    value={data.countryId}
                                    defaultValue={data.countryId}
                                    onChange={(e) => onUpdateString('countryId', e.target.value)}
                                >
                                    {countries.map((item) => (
                                        <MenuItem
                                            key={item.value}
                                            value={item.value}
                                        >
                                            {item.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box>
                            <TextField error={data.locationError} fullWidth label="Location" placeholder="Location" size="small" type="text" value={data.location} onChange={(e) => onUpdateString('location', e.target.value)} />
                        </Box>

                        <Box sx={{ flexBias: 0, flexGrow: 1 }}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="type-label">Incoming Call Action</InputLabel>
                                <Select
                                    error={data.incomingCallActionError}
                                    label="Incoming Call Action"
                                    labelId="type-label"
                                    fullWidth
                                    value={data.incomingCallAction}
                                    defaultValue={data.incomingCallAction}
                                    onChange={(e) => onUpdateString('incomingCallAction', e.target.value)}
                                >
                                    <MenuItem value='FORWARD'>Forward</MenuItem>
                                    <MenuItem value='VOICEMAIL'>Voice mail</MenuItem>
                                    <MenuItem value='MANUAL_ANSWER'>Manual Answer</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>

                        {data.incomingCallAction === "FORWARD" && <Box>
                            <TextField error={data.forwardToNumberError} fullWidth label="Forward to Number" placeholder="Forward to Number" size="small" type="text" value={data.forwardToNumber} onChange={(e) => onUpdateString('forwardToNumber', e.target.value)} />
                        </Box>}
                    </Box>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 4 }}>
                <Button variant="contained" size="small" endIcon={<CloseIcon />} style={{ color: 'white' }} onClick={onClose}>Close</Button>
                <Button variant="contained" size="small" endIcon={<SaveIcon />} style={{ color: 'white' }} onClick={onSave}>Save</Button>
            </Box>
        </Box>
    </SimpleDialog>
}

export default EditPhoneNumber;